import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { currentUser, userProfile } = useAuth();
  const location = useLocation();
  const path = location.pathname;

  // Check if user is authenticated
  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if email is verified
  if (!currentUser.emailVerified) {
    // For development mode with mock Firebase
    const isDevelopment = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCK_FIREBASE === 'true';
    const devModeUser = localStorage.getItem('devModeUser');
    
    if (isDevelopment && devModeUser) {
      const parsedUser = JSON.parse(devModeUser);
      if (parsedUser.emailVerified) {
        // Allow access if dev mode user is verified
        // Continue to role-based access check
      } else {
        // Store the intended destination for after verification
        localStorage.setItem('redirectAfterVerification', location.pathname);
        
        // Redirect to email verification page
        return <Navigate to="/email-verification" state={{ from: location }} replace />;
      }
    } else {
      // Store the intended destination for after verification
      localStorage.setItem('redirectAfterVerification', location.pathname);
      
      // Redirect to email verification page
      return <Navigate to="/email-verification" state={{ from: location }} replace />;
    }
  }

  // Role-based access control
  // Check if user is trying to access brand routes but is an influencer
  if (path.startsWith('/brand') && userProfile?.userType !== 'brand') {

    return <Navigate to="/influencer" replace />;
  }
  
  // Check if user is trying to access influencer routes but is a brand
  if (path.startsWith('/influencer') && userProfile?.userType !== 'influencer') {

    return <Navigate to="/brand" replace />;
  }

  return children;
};

export default PrivateRoute;
